module.exports = __webpack_public_path__ + "img/mobile-detail-report.6b4f3170.png";